<template>
  <div
      class="fixed top-0 left-0 right-0 translate-y-[-150%] transition-transform translate bg-white dark:bg-black md:shadow-page dark:text-steel dark:md:shadow-[#000]/20 dark:shadow-[#111]/20 dark:text-white p-4 sm:p-2 w-screen z-50"
      ref="localeSuggester" v-show="showLocaleSuggester">
    <div class="container mx-auto sm:flex items-center">
      <p class="w-full mr-4 mb-2 sm:mb-0">{{ $t('Vielleicht möchten Sie zu einer anderen Sprache wechseln?') }}</p>
      <locale-switcher :with-shadow="false" :entry-id="entryId"></locale-switcher>
      <button class="mt-2 sm:mt-0 sm:ml-4 px-2 whitespace-nowrap" @click.prevent="stay" :title="$t('Schließen')">
        {{ $t('Jetzige Sprache nutzen') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
import LocaleSwitcher from "@/components/LocaleSwitcher";

const $t = inject("translator");

const showLocaleSuggester = ref(false);
const localeSuggester = ref(null);

const props = defineProps({
  entryId: Number,
})

onMounted(() => {
  if (shouldSuggestLocaleSwitch()) {
    toggleLocaleSuggester();
  }
})

const stay = () => {
  localStorage.setItem('user-set-locale', '1');
  toggleLocaleSuggester();
}

const toggleLocaleSuggester = () => {
  if (showLocaleSuggester.value) {
    localeSuggester.value.classList.add('translate-y-[-150%]');
    setTimeout(() => {
      showLocaleSuggester.value = false;
    }, 1000);
  } else {
    showLocaleSuggester.value = true;
    setTimeout(() => {
      localeSuggester.value.classList.remove('translate-y-[-150%]');
    }, 1000);
  }
}

const browserLocaleIsGerman = () => window.navigator.language.indexOf('de-') === 0;

const shouldSuggestLocaleSwitch = () => {
  if (localStorage.getItem('user-set-locale') === '1') {
    return false;
  }
  if (browserLocaleIsGerman() && window.headlessTranslator.locale === 'en') {
    return true;
  }
  if (!browserLocaleIsGerman() && window.headlessTranslator.locale === 'de') {
    return true;
  }
  return false;
}
</script>
